import { EmployeeController } from '../../controllers';
import React, { useMemo, useState } from 'react';
import { CommisionTable } from '../../pages';

const CommisionTableContainer = () => {
	const [limit, setLimit] = useState(50);
	const [filterQuery, setFilterQuery] = useState('');
	const [currentPage, setCurrentPage] = useState(0);
	const [searchQuery, setSearchQuery] = useState('');

	const commisionTableQuery = useMemo(() => {
		return `offset=${currentPage + 1}&limit=${limit}`;
	}, [currentPage, limit]);

	const { isLoading, data, isFetching } = EmployeeController.useGetCommisions(
		commisionTableQuery,
		filterQuery,
		searchQuery
	);

	const onLimitChange = limit => {
		setLimit(limit);
		setCurrentPage(0);
	};

	return (
		<div>
			<CommisionTable
				isLoading={isLoading}
				data={data}
				isFetching={isFetching}
				limit={limit}
				onLimitChange={onLimitChange}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
				setSearchQuery={setSearchQuery}
			/>
		</div>
	);
};

export default CommisionTableContainer;
